import {styled} from '@mui/system'

export const TherapyCardStyled = styled('div')(({theme}) => ({
  border: '1px solid #edf1f2',

  '.therapy-selector-tabs.ant-tabs': {
    borderBottom: '1px solid #edf1f2',

    '.ant-tabs-nav': {
      padding: '0 16px',
      margin: 0,

      '&:before': {
        display: 'none'
      }
    },

    '.ant-tabs-nav-operations': {
      display: 'none'
    },

    '.ant-tabs-ink-bar': {
      backgroundColor: `${theme.palette.primary.main} !important`
    },

    '.ant-tabs-tab': {
      padding: '12px 16px',
      fontSize: '14px',
      fontWeight: 400,
      color: '#000',
      border: 'none',
      borderBottom: '3px solid transparent',
      transition: 'all 0.3s ease',
      marginBottom: '-1px',

      '&.ant-tabs-tab-active': {
        borderBottomColor: theme.palette.primary.main,

        '.ant-tabs-tab-btn': {
          color: '#000'
        }
      }
    }
  },

  '#therapy-form': {
    display: 'grid',
    padding: '16px',
    gridTemplateColumns: 'repeat(3, 1fr)',
    columnGap: '10px',

    '.ant-row': {
      width: '100%'
    },

    '.ant-form-item-label > label': {
      fontSize: theme.spacing(6),
      color: '#222'
    },

    '.ant-input': {
      height: theme.spacing(19),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    },

    '.ant-input[disabled]': {
      backgroundColor: '#eee',
      borderColor: '#ccc',
      color: '#555'
    },

    '.ant-picker': {
      width: '100%',
      height: theme.spacing(19),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      backgroundColor: '#eee'
    },

    '.ant-picker-input > input[disabled]': {
      backgroundColor: '#eee',
      borderColor: '#ccc',
      color: '#555'
    }
  },

  '.save-button-container': {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '16px'
  }
}))
